module.exports = __webpack_public_path__ + "img/author9.f7cb5122.jpg";